var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentBoNavigationHeadlines &&
    _vm.currentBoNavigationHeadlines.length > 0
    ? _c(
        "div",
        {
          class: [
            "headlines-component",
            { "not-plain": !_vm.isplain },
            { isplain: _vm.isplain },
            "has-headline",
            "lines-" + _vm.showHeadlinesLines
          ]
        },
        [
          _vm.currentBoNavigationHeadlines &&
          _vm.currentBoNavigationHeadlines.length > 0
            ? _c(
                "div",
                { staticClass: "headline-wrapper" },
                [
                  !_vm.isplain
                    ? _vm._l(_vm.currentBoNavigationHeadlines, function(
                        headline,
                        index
                      ) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: [
                              "headline",
                              {
                                active:
                                  headline.idfwheadline ===
                                  _vm.selectedTab.idfwheadline
                              },
                              { "not-plain": !_vm.isplain }
                            ],
                            style: _vm.setBackground(headline, true)
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "promo-container",
                                style: {
                                  backgroundImage:
                                    "url(" + headline.imageurl + ")"
                                }
                              },
                              [
                                headline.bodytext
                                  ? _c(
                                      "div",
                                      { staticClass: "text-background" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "promo-content" },
                                          [
                                            _c("p", {
                                              staticClass: "bodytext",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  headline.bodytext
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isplain
                    ? [
                        _vm.currentBoNavigationHeadlines &&
                        _vm.currentBoNavigationHeadlines[0] &&
                        _vm.currentBoNavigationHeadlines[0].imageurl
                          ? _c("div", {
                              staticClass: "background-image",
                              style: {
                                backgroundImage:
                                  "url(" +
                                  _vm.currentBoNavigationHeadlines[0].imageurl +
                                  ")"
                              }
                            })
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7403adf4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7403adf4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cdu/headlines/headlines.vue
// module id = null
// module chunks = 